import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SingleLineScrollTrack from "@/components/landing/SingleLineScrollTrack";

const TABS = [
  { id: "schools", label: "Schools" },
  { id: "franchise", label: "Franchise" },
  { id: "store", label: "Stores" },
  { id: "creator", label: "TV & Academies" },
  { id: "open_student", label: "Students" },
];

export default function TabbedPlans() {
  const [all, setAll] = useState({});
  const [tab, setTab] = useState("schools");
  const [ccy, setCcy] = useState(localStorage.getItem("ponderr_ccy") || "INR");

  useEffect(() => { api.get("/membership/plans/all").then(r => setAll(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const h = () => setCcy(localStorage.getItem("ponderr_ccy") || "INR");
    window.addEventListener("ponderr-ccy", h);
    return () => window.removeEventListener("ponderr-ccy", h);
  }, []);

  const fmt = (p) => {
    const v = p.effective_price ?? p.base_price ?? 0;
    if ((p.currency || "INR") === "USD") return `$${Number(v).toLocaleString()}`;
    return ccy === "USD" ? `$${Math.round(Number(v) / 83).toLocaleString()}` : `₹${Number(v).toLocaleString()}`;
  };
  const plans = all[tab] || [];

  return (
    <section id="plans" className="max-w-7xl mx-auto px-6 py-12" data-testid="tabbed-plans">
      <h2 className="display text-3xl font-bold mb-4">Membership Plans</h2>
      <div className="flex flex-nowrap overflow-x-auto no-scrollbar gap-2 mb-5">
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`plans-tab-${t.id}`}
            className={`pf-btn shrink-0 text-sm ${tab === t.id ? "" : "!bg-transparent !shadow-none"}`}>{t.label}</button>
        ))}
      </div>
      <div className="grid grid-cols-1">
        <SingleLineScrollTrack testid="track-plans" itemClass="w-[300px] sm:w-[340px]">
          {plans.map((p, i) => (
            <div key={p.id || i} className="nb-card p-6 pf-surface border-2 pf-border h-full flex flex-col" data-testid={`landing-plan-${p.id || i}`}>
              <h3 className="display text-2xl font-bold break-words line-clamp-2">{p.name}</h3>
              <div className="display text-3xl font-black mt-2">
                {fmt(p)}<span className="text-sm font-normal">/{p.billing_interval === "monthly" ? "mo" : "yr"}</span>
              </div>
              <div className="flex flex-wrap gap-1 mt-1">
                {p.trial_days > 0 && <span className="nb-badge pf-accent-bg text-[10px]">{p.trial_days}-day trial</span>}
                {p.commission_pct != null && <span className="nb-badge bg-[#FCA5A5] text-[10px]">{p.commission_pct}% take-rate</span>}
              </div>
              <ul className="mt-3 space-y-1 text-sm">
                {(p.features || []).map((f, j) => <li key={j} className="flex gap-2"><span>✓</span>{f}</li>)}
              </ul>
            </div>
          ))}
          {plans.length === 0 && <div className="nb-card p-8 text-center pf-muted w-[300px]">No plans in this category yet.</div>}
        </SingleLineScrollTrack>
      </div>
    </section>
  );
}
